import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { TypedMemo } from '../../../common/types';
import { CatalogView } from '../CatalogView';
import { SoundCloudReturnPage } from './SoundCloudReturnPage';

/**
 * `/app/catalog/connect/soundCloud`. With `?state=` it is the return page of the SoundCloud sign-in
 * (design b; MusicAPI sends the browser here). Without it, it is the connect link of the app, as
 * for every other service: the Catalog opens the connect of SoundCloud.
 */
const SoundCloudReturnViewComponent: React.FC = () => {
  const [params] = useSearchParams();
  const state = params.get('state');
  return state === null || state === '' ? <CatalogView /> : <SoundCloudReturnPage state={state} />;
};

export const SoundCloudReturnView = TypedMemo(SoundCloudReturnViewComponent);
